import { IVolatilitySurfaceMarkingWidgetProps } from './types';
import VolatilitySurfaceMarkingWidget from './volatility-surface-marking-widget';

const VolatilitySurfaceMarkingWrapperProvider = (props: IVolatilitySurfaceMarkingWidgetProps) => {
  return <VolatilitySurfaceMarkingWidget {...props} />;
};

export default VolatilitySurfaceMarkingWrapperProvider;
